import classNames from 'classnames'
import { MdOutlineClear, MdInfoOutline } from 'react-icons/md'

import type { ReactElement, ReactNode } from 'react'

import Tooltip from '~/components/Tooltip'

import './styles.scss'

export interface Props {
  className?: string
  onRemove: VoidFunction
  size?: Exclude<SIZES, 'small'>
  tooltip?: ReactNode
  value: string
  variant?: 'primary' | 'secondary'
}

const Tag = ({ className, onRemove, size = 'large', tooltip, value, variant = 'primary' }: Props): ReactElement => {
  const classes = classNames('tag-component', className, size, { 'with-tooltip': !!tooltip }, variant)

  return (
    <div className={classes}>
      <div className="tag-component__value">
        {!!tooltip ? (
          <Tooltip
            align={{ points: ['bl', 'tl'] }}
            mouseEnterDelay={0.2}
            overlay={tooltip}
            placement="topRight"
            trigger={['hover']}
          >
            <div className="tag-component__tooltip-icon">
              <MdInfoOutline color="#ff5301" size={14} />
            </div>
          </Tooltip>
        ) : null}
        {value}
      </div>
      <div className="tag-component__close-icon" onClick={onRemove}>
        <MdOutlineClear color={variant === 'primary' ? '#ff5301' : '#975d04'} role="icon" size={14} />
      </div>
    </div>
  )
}

export default Tag
